// project imports
import {
    processEntityInput as processEntityInputMain,
    processEntityOutput as processEntityOutputMain
} from 'store/serializers/fragments/main';

export const processEntityInput = (values) => ({ ...values, ...processEntityInputMain(values) });

export const processEntityOutput = (values) => ({ ...values, ...processEntityOutputMain(values) });
